import React from 'react'

const CTAButton = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    const id = e.currentTarget.hash

    window.history.pushState(null, null, id)
    document.querySelector(id).scrollIntoView({behavior: 'smooth'})
  }

  return (
    <a
      href='#upload'
      title='ทดลองอัปโหลดรูป'
      className='DemoDetail__button'
      onClick={handleClick}
    >
      ทดลองอัปโหลดรูป
    </a>
  )
}

export {CTAButton}
